export default __webpack_public_path__ + "static/media/logo.fceb97d6.svg";